/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */

import React, { useRef, useState} from 'react';
import CustomTd from '../../../../components/table/CustomTd';
import DropDownMenuItem from '../../../../components/DropDown/DropDownMenuItem';
import DropDownMenuProfile from '../../../../components/DropDown/DropDownMenuProfile';
import { DeleteIconsOptions } from '../../../../components/buttons/IconButtons';
import TableFunction from '../../../../components/table/TableFunction';
import { TABLES } from '../../../../Apis/Tables';
import CustomTh from '../../../../components/table/CustomTh';
import { useDispatch} from 'react-redux';
import { useTranslation } from 'react-i18next';
import {EMPTY_VALUES, errorMsg} from '../../../../Apis/functions';
import { DeleteItemsApi } from '../../../../reduxToolkit/Commons/CommonsApi';
import {SEARCH_MODEL} from "../../../../components/table/Model/TableModel";
import {SimpleSearchWithId} from "../../../../reduxToolkit/Search/SearchApi";
import {VIEW_TYPE} from "../../../../enums/ViewType";

const CategoriesApp = () => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const [tableId, setTableId] = useState('tbl_ca_categories');
    const [searchId, setSearchId] = useState('txt_ca_categories');
    const [modified, setModified] = useState(false);
    const [results, setResults] = useState();
    const [searchElement, setSearchElement] = useState(''); // Search filter value
    const [simpleSearch, setSimpleSearch] = useState(false); // Simple search flag
    const [search, setSearch] = useState(false); // Search flag
    const [bodyForExport, setBodyForExport] = useState('');
    const [contractorId, setContractorId] = useState(sessionStorage.getItem('contractorId'));
    const [supplierId, setSupplierId] = useState(sessionStorage.getItem('providerId'));
    const [deleteShow, setDeleteShow] = useState(false); // Controls visibility of the delete confirmation modal
    const [selectedCategoryForDelete, setSelectedCategoryForDelete] = useState(null); // Stores the selected category to be deleted
    const [createCategoryShow, setCreateCategoryShow] = useState(false); // Controls visibility of the "Create Category" modal
    const [isAllChecked, setIsAllChecked] = useState(false);
    // API table option used for category operations
    const option = TABLES.CATEGORY;
    const viewType = VIEW_TYPE.LIST.viewType;
    const elementRef = useRef(null);

    // Generates the table header configuration
    const getThead = () => {
        return [<CustomTh tableId={tableId}  classes='first_head'></CustomTh>];
    };

    // Function to generate the table body
    const getTbody = () => {
        if (!results || results?.content?.length === 0)
            return {
                body: [],
                data: [],
            };

        let body = results?.content?.map((item) => {
            return (
                <>
                    <CustomTd tableId={tableId} tooltip={item?.name} classes='first-column'>
                        {item?.name || EMPTY_VALUES.DEFAULT}
                    </CustomTd>
                </>
            );
        });

        return { body, data: results?.content };
    };

    // Renders action buttons for each table row
    const getActionsButtons = (item) => {
        return (
            <>
                <DropDownMenuProfile openMenu={openMenu} handleMenuToggle={handleMenuToggle} menuId={`menu-${item.id}`}>
                    <DropDownMenuItem
                        index={item?.id}
                        handleClose={handleClose}
                        name={t('delete')}
                        fontColor='font-color-error-600'
                        iconColor={'icon-color-error-code-600'}
                        click={() => handleDelete(item)}
                        icon={<DeleteIconsOptions />}
                    />
                </DropDownMenuProfile>
            </>
        );
    };

    // Opens delete confirmation modal and stores the selected category
    const handleDelete = (item) => {
        setSelectedCategoryForDelete({
            ...item,
            category: option,
        });

        setDeleteShow(true);
    };

    // Deletes the selected category via API
    const deleteCategory = (item) => {

        dispatch(
            DeleteItemsApi({
                tableName: option,
                body: [item.id],
            }),
        ).then(
            ({
                payload: {
                    data: { success, code },
                },
            }) => {
                if (success) {
                    setDeleteShow(false);
                    setSelectedCategoryForDelete(null);
                    setModified(true);
                } else {
                    errorMsg(code);
                }
            },
        );
    };

    /**
     * Executes a paginated search request using basic criteria.
     *
     * Builds the request body with the current page, page size, selected model,
     * and any additional criteria passed as arguments.
     * Triggers the search action through Redux and updates the results on success.
     */
    const getData = ( page, {searchElement}) => {
        const body = SEARCH_MODEL.setObject({page, size:rowsPerPage, model:option, key:searchElement, userId:contractorId, viewType: viewType});//VIEW_TYPE.LIST.viewType == CATEGORY identifier
        dispatch(SimpleSearchWithId({ body })).then(
            ({payload: {data: { data, success }}}) => {
                if (success === true) {
                    setResults(data);
                }
            },
        );
    };

    // Table configuration and handlers
    const { thead, tbody, pagination, page, rowsPerPage, handleMenuToggle, handleClose, openMenu } = TableFunction({
        data: results,
        getThead,
        getTbody,
        labelRowsPerPage: 'categories_per_page',
        fixedPagination: false,
        hasContainer: true,
        setIsAllChecked,//New
        searchElement, //New
        getData,//New
        modified,//New
        setModified,//New
    });

    return {
        t,
        tableId,
        searchId,
        thead,
        tbody,
        getActionsButtons,
        pagination,
        contractorId,
        supplierId,
        searchElement,
        setSearchElement,
        setResults,
        option,
        page,
        rowsPerPage,
        setSearch,
        setSimpleSearch,
        setBodyForExport,
        deleteShow,
        setDeleteShow,
        selectedCategoryForDelete,
        setSelectedCategoryForDelete,
        deleteCategory,
        createCategoryShow,
        setCreateCategoryShow,
        setModified,
        viewType,
        isAllChecked,
        elementRef
    };
};

export default CategoriesApp;
